// {
//     "name": "underscore",

//     "scriptsToInclude": ["~/Scripts/underscore.js"]
//   },
import underscore from 'underscore/underscore-min.js'
window._ = underscore
// validated: esbuild